/*
 * Usage: callAll(functionA, functionB, functionC) -> Every function listed will be called
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function callAll(...fns: any[]) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (...args: any[]): void => fns.forEach((fn) => fn?.(...args))
}
